export default "__VITE_ASSET__BMTVfDKh__"